import { useEffect, useState } from "react";
import { getUsageTop, recordLaunch } from "../lib/api";
import { useAuthUser } from "../lib/useAuthUser";

/**
 * Per-user "most used" quick-launch strip. Logged-in only (usage is tracked
 * server-side, keyed by the user's email). Renders nothing for anonymous
 * visitors or when the user has no launch history yet.
 */
export default function MostUsedStrip({ className = "" }) {
  const { user } = useAuthUser();
  const [tools, setTools] = useState([]);

  useEffect(() => {
    if (!user) {
      setTools([]);
      return undefined;
    }
    let mounted = true;
    getUsageTop(6)
      .then((d) => {
        if (mounted) setTools(d.tools || []);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [user]);

  if (!user || tools.length === 0) return null;

  return (
    <div className={`mb-6 ${className}`} data-testid="most-used-strip">
      <div className="text-[11px] text-[#888] mb-1.5">
        {">"} your most used
      </div>
      <div className="flex flex-wrap gap-2">
        {tools.map((t) => (
          <a
            key={t.id}
            href={t.url}
            target="_blank"
            rel="sponsored noopener noreferrer"
            onClick={() => recordLaunch(t.id)}
            className="inline-flex items-baseline gap-1.5 border border-black px-2.5 py-1 text-[12px] hover:bg-black hover:text-white transition-colors"
            data-testid={`most-used-${t.id}`}
            title={`Launch ${t.title} ↗`}
          >
            <span className="font-bold">{t.title}</span>
            <span className="text-[10px] opacity-70">↗</span>
            <span className="text-[10px] tabular-nums opacity-60">{t.count}×</span>
          </a>
        ))}
      </div>
    </div>
  );
}
